import './SubjectsList.scss';

import groupby from 'lodash.groupby';
import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { selectSubjectsEntities } from 'shared/store/curriculums';

import cx from 'utils/cx';
import Badge from './Badge';

const SubjectsList = ({
  subjects,
  curriculums,
  slice,
  hideOverflow,
  onlyCurriculums,
  onlyText,
}) => {
  const subjectsEntities = useSelector(selectSubjectsEntities);

  if ((!subjects?.length || isEmpty(subjectsEntities)) && !curriculums.length) {
    return <span>-</span>;
  }

  // return text: 'IB Biology EE, IB Biology EE'
  if (onlyText) {
    return (
      <span>
        {subjects.map((subjectId, index) => {
          const { subject, curriculum } = subjectsEntities[subjectId] || {};
          return `${curriculum} ${subject}${
            index !== subjects.length - 1 ? ', ' : ''
          }`;
        })}
      </span>
    );
  }

  const subjectsByCurriculums = groupby(
    subjects.map((val) => subjectsEntities[val?.id || val]).filter((s) => s),
    'curriculum',
  );

  // return only category: '<Badge>IB</Badge> <Badge>AP</Badge>'
  if (onlyCurriculums) {
    return (
      <ul className="subjects-lists">
        {curriculums.map((curriculum) => (
          <li key={curriculum} className="profile-subjects-list-el">
            <Badge color="secondary">{curriculum}</Badge>
          </li>
        ))}
        {Object.keys(subjectsByCurriculums).map((curriculum) => (
          <li key={curriculum} className="profile-subjects-list-el">
            <Badge color="secondary">{curriculum}</Badge>
          </li>
        ))}
      </ul>
    );
  }

  // return normal if subject array: '<Badge>IB</Badge> Biology EE <Badge>AP</Badge> Biology EE'
  return (
    <>
      {curriculums.slice(0, slice).map((curriculum) => (
        <p
          key={curriculum}
          className={cx('profile-subjects-list-el', {
            'hide-overflow': hideOverflow,
          })}
        >
          <Badge color="secondary">{curriculum}</Badge>
        </p>
      ))}
      {Object.entries(subjectsByCurriculums)
        .slice(0, slice - curriculums.length)
        .map(([curriculum, subjects]) => (
          <p
            key={curriculum}
            className={cx('profile-subjects-list-el', {
              'hide-overflow': hideOverflow,
            })}
          >
            <Badge color="secondary">{curriculum}</Badge>
            {subjects?.map(
              ({ subject }, index) =>
                subject + (index !== subjects.length - 1 ? ', ' : ''),
            )}
          </p>
        ))}
    </>
  );
};

SubjectsList.propTypes = {
  subjects: PropTypes.array,
  curriculums: PropTypes.array,
  slice: PropTypes.number,
  hideOverflow: PropTypes.bool,
  onlyCurriculums: PropTypes.bool,
  onlyText: PropTypes.bool,
};

SubjectsList.defaultProps = {
  subjects: [],
  curriculums: [],
  slice: 100,
  hideOverflow: false,
  onlyCurriculums: false,
  onlyText: false,
};

export default memo(SubjectsList);
